import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=3b09c5d2&scoped=true"
import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b09c5d2",
  null
  
)

export default component.exports